<div class="print-container">
  <nav class="navbar">
    <div style="flex: 1;">
      
      <!-- <img src="/assets/adv.png" alt="Logo" width="50"> -->
      <!-- <ng-container *ngIf="this.whitelabel.$whiteLabelDetails | async as whitelabel">
        <img [src]="whitelabel.smallLogoUrl" alt="Logo" width="50">
      </ng-container> -->
    </div>
    <div class="nav-icons">
      <a title="Print" (click)="handlePrint()"><i class="fas fa-print"></i></a>
      <a *ngIf="showEmail" title="Email" (click)="handleEmail()"><i class="fas fa-envelope"></i></a>
      <a title="Excel" (click)="handleExcel()"><i class="fas fa-file-excel"></i></a>
      <a title="PDF" (click)="handlePDF()"><i class="fas fa-file-pdf"></i></a>
    </div>
  </nav>

  <iframe #previewFrame class="preview-frame"></iframe>
</div>

<iframe #pdfFrame style="display: none;"></iframe>


